import { configureStore } from '@reduxjs/toolkit';
import signalrMiddleware from './middleware/signalrMiddleware';
import tasksReducer from './slices/tasksSlice';
import patrolsReducer from './slices/patrolsSlice';
import shiftsReducer from './slices/shiftsSlice';
import mappingReducer from './slices/mappingSlice';
import authReducer from "./slices/authSlice"; 
import constantsReducer from './slices/constantsSlice';
import notificationReducer from "./slices/notificationSlice";
import auditReducer from "./slices/auditSlice";
import garagesReducer from "./slices/garagesSlice";

export const store = configureStore({
  reducer: {
    tasks: tasksReducer,
    patrols: patrolsReducer,
    mapping: mappingReducer,
    constants: constantsReducer,
    shifts: shiftsReducer,
    auth: authReducer,
    notification: notificationReducer,
    audit: auditReducer,
    garages: garagesReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(signalrMiddleware),
});